<template>
	<div class="white fill-height">
		<v-toolbar flat class="sticky-top" color="primary" dark height="80">
			<v-container>
				<v-row align="center">
					<v-col cols="auto">
						<v-toolbar-title>
							{{ $t('ShoppingCart.Bestellen') }}
						</v-toolbar-title>
					</v-col>
				</v-row>
			</v-container>
		</v-toolbar>

		<v-container>
			<v-row class="white" no-gutters justify="space-between">
				<!-- ORDER SUMMARY -->
				<v-col md="5">					
					<OrderSummary />
				</v-col>	
				<!-- ORDER DETAILS -->			
				<v-col md="6">
					<!-- ADDRESS INFO -->	
					<v-card flat>
						<v-card-title>{{ $t('ShoppingCart.Adres_info') }}</v-card-title>
						<v-card-subtitle>{{ $t('ShoppingCart.Selecteer_een_afleveradres_en_een_factuuradres') }}</v-card-subtitle>
						<v-card-text >							
							<DeliveryAddressPicker/>
							<InvoiceAddressPicker class="mt-4"/>
						</v-card-text>
					</v-card>
					
					<!-- ORDER INFO -->
					<v-card flat>
						<v-card-title>{{ $t('ShoppingCart.Bestel_info') }}</v-card-title>
						<v-card-subtitle>{{ $t('ShoppingCart.Referentie_en_opmerking_meegeven') }}</v-card-subtitle>
						<v-card-text>							
							<v-text-field v-model="reference" :label="$t('ShoppingCart.Referentie')" outlined hide-details/>
							<v-textarea v-model="remark" :label="$t('ShoppingCart.Opmerking')" rows="3" outlined hide-details class="mt-4"/>
						</v-card-text>
					</v-card>
					<v-toolbar flat dense class="mt-8">
						<v-spacer />
						<v-btn x-large block outlined color="primary" @click.stop="convertCart" :loading="loading" :disabled="!deliveryAddressId || !invoiceAddressId">{{
							$t('ShoppingCart.Bestelling_plaatsen') }}</v-btn>
					</v-toolbar>
				</v-col>
			</v-row>		
		</v-container>

		<v-dialog v-model="showResultDialog" max-width="600">
			<v-card flat max-width="600" class="mx-auto ">
				<v-card-title>
					{{ $t('ShoppingCart.Thank_you') }} {{ firstName }} !
				</v-card-title>
				<v-card-subtitle>
					{{ $t('ShoppingCart.We_will_send_an_order_confirmation') }}
				</v-card-subtitle>
				<v-card-text class="pt-8">
					<v-banner :icon="errorMsg ? 'mdi-close' : 'mdi-check'" :icon-color="errorMsg ? 'red' : 'green'">
						<span v-if="errorMsg">{{ this.errorMsg }}</span>
						<span v-else>{{ this.result }}</span>
						<template v-slot:actions>
							<v-btn plain :to="{ name: 'Home' }">
								{{ $t('ShoppingCart.OK') }}
							</v-btn>
						</template>
					</v-banner>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import DeliveryAddressPicker from "@/components/DeliveryAddressPicker";
import InvoiceAddressPicker from "@/components/InvoiceAddressPicker";
import OrderSummary from "@/components/OrderSummary";

export default {
	name: "ShoppingCart",
	components: {
		DeliveryAddressPicker,
		InvoiceAddressPicker,
		OrderSummary,
	},
	data() {
		return {
			loading: false,
			errorMsg: null,
			result: "",
			showResultDialog: false,
		};
	},
	created() {
		this.$store.dispatch("shoppingCart/fetchShoppingCart").then(() => {
			this.$store.dispatch("shoppingCart/fetchAddressList");
		});
	},
	computed: {
		...mapGetters({
			cart: "shoppingCart/cart",
			cartItemCount: "shoppingCart/cartItemCount",
			deliveryAddressList: "shoppingCart/deliveryAddressList",
			invoiceAddressList: "shoppingCart/invoiceAddressList",
			deliveryAddressId: "shoppingCart/deliveryAddressId",
			invoiceAddressId: "shoppingCart/invoiceAddressId",
			firstName: "session/firstName",
			email: "session/email"
		}),
		remark: {
			get() {
				return this.$store.state.shoppingCart.remark;
			},
			set(text) {
				this.$store.dispatch("shoppingCart/setRemark", text);
			},
		},
		reference: {
			get() {
				return this.$store.state.shoppingCart.reference;
			},
			set(text) {
				this.$store.dispatch("shoppingCart/setReference", text);
			},
		},
	},
	methods: {
		convertCart() {
			this.loading = true;
			this.$store
				.dispatch("shoppingCart/convertShoppingCart")
				.then((response) => {
					this.result =
						this.$t('ShoppingCart.Your_order_nr') + ': ' +
						response.data.success.orderId;
					this.$store.dispatch("session/fetchDashboardInfo");
				})
				.catch((error) => {
					this.errorMsg = error;
				})
				.finally(() => {
					this.loading = false;
					this.showResultDialog = true;
				});
		},
	},
};
</script>
